/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable-next-line array-callback-return */
import TeamsGrid from './Grid';
import TeamsForm from './Create';
import { NavLink } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import SideDrawer from '../../Components/SideDrawer';
import { useDispatch, useSelector } from 'react-redux';
import ContentWrapper from '../../Layouts/AdminLTE/ContentWrapper';
import { LoadResourceAction } from '../../Redux/Actions/CrudActions';
import TeamsCreate from './Create';

export default function TeamsIndex() {

    const PAGE_NAME = 'Teams';

    const CREATE_BUTTON_NAME = 'Create a Team';

    const BACKEND_ROUTE = 'teams';

    const ACTION_TYPE = "COMMON";

    const [tablecolumn, setTablecolumn] = useState({
        columns: [
            { title: 'Team Name', field: 'name' },
            { title: 'Team Status', render: rowData => <div> 
                {rowData.status === 1 ? 
                <span className="badge badge-pill badge-success">Active</span> 
                : <span className="badge badge-pill badge-danger">Inactive</span>}
            </div> },
            { title: 'Utility Name', render: rowData => <div> 
                {rowData.utility_departments.length > 0 
                ? rowData.utility_departments[0].utility.name 
                : "-"}
            </div> },
            { title: 'Location', field: 'location.name' },
            { title: 'Created At', field: 'created_at' },
            { title: 'Updated At', field: 'updated_at' },
        ]
    });

    const dispatch = useDispatch();

    const [data, setData] = useState([]);

    const state = useSelector(state => state.common);

    const [DrawerCreateStatus, setDrawerCreateStatus] = useState(false);
    const permisions = localStorage.getItem('permissions');

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        dispatch(LoadResourceAction(BACKEND_ROUTE, ACTION_TYPE, signal));
        return () => {
            controller.abort();
            console.log("Aborted Customer");
        }
    }, []);

    useEffect(() => {
        if (state.all.success && state.all.list) {
            setData(state.all.list);
            dispatch({ type: `RESTART_${ACTION_TYPE}_LIST` });
        }
    }, [state]);

    const HandleDrawerCreate = () => {
        if (DrawerCreateStatus === false) {
            setDrawerCreateStatus(true);
        } else if (DrawerCreateStatus === true) {
            setDrawerCreateStatus(false);
        }
    }

    return (
        <ContentWrapper page_name={PAGE_NAME} breadcrumbs={breadcrumbs(PAGE_NAME)}>
            <div className="card rounded">
                {permisions.includes('create_team')
                &&
                    <SideDrawer
                        status={DrawerCreateStatus}
                        action_heading={CREATE_BUTTON_NAME}
                        handle={HandleDrawerCreate}>
                        {DrawerCreateStatus && <TeamsCreate />}
                    </SideDrawer>
                }
                <div className="card-body p-0">
                    <TeamsGrid
                        dataList={data}
                        Title={PAGE_NAME}
                        setDataList={setData}
                        columns={tablecolumn}
                        HandleDrawerCreate={HandleDrawerCreate}
                    />
                </div>
            </div>
        </ContentWrapper>

    );
};
function breadcrumbs(PageName, IndexRoute = false, IndexPageName = false) {
    return (
        <>
            {IndexPageName && <li className="breadcrumb-item">
                <NavLink to={IndexRoute}>{IndexPageName}</NavLink></li>}
            <li className="breadcrumb-item active">{PageName}</li>
        </>
    )
}
